import { defineMessage } from 'services/localization';

export const messages = {
    confirmButtonTitle: defineMessage('confirm'),
    cancelButtonTitle: defineMessage('cancel'),
    description: defineMessage('confirm_uploading_file'),
    successText: defineMessage('your_data_has_been_extracted'),
    errorText: defineMessage('approvalmax_capture_has__to_recognize_your_file'),
    errorButtonText: defineMessage('lets_try_again'),
    ocrDocumentIsEmptyButtonText: defineMessage('lets_try_again_1'),
    ocrDocumentIsEmptyText: defineMessage('no_data_has_been_extrac_ase_upload_another_file'),
};
